// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"b2e14f85","375":"c43b4b1b","483":"bac0123b","532":"5317108b","717":"bd99c372","778":"eef9ffe9","815":"f0e10312"}[chunkId] + ".chunk.js";
};